import { Parts } from "./parts";
import { Comment } from "./comments";
import { TimeLine } from "./time-line";

export class Ticket {
  id: number | null;
  title: string;
  description: string;
  registrant: string;
  registeredBy: number;
  account: string;
  branchId: number;
  statusId: number | null;
  responsible: string;
  assigned: number;
  departmentId: number | null;
  accountmanager: string;
  priorityId: number | null;
  date_done: Date | null;
  created: string;
  modified: string;
  durationEstimate: string;
  archived: boolean;
  parts: Parts;
  comments: Comment;
  timeline?: TimeLine[];

  constructor(
    id: number | null,
    title = "",
    description = "",
    registrant = "",
    registeredBy = 0,
    account = "",
    branchId = 0,
    statusId = 0,
    responsible = "",
    assigned = 0,
    departmentId = 0,
    accountmanager = "",
    priorityId = 0,
    date_done: Date | null = null,
    durationEstimate = "",
    archived = false
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.registrant = registrant;
    this.registeredBy = registeredBy;
    this.account = account;
    this.branchId = branchId;
    this.statusId = statusId;
    this.responsible = responsible;
    this.assigned = assigned;
    this.departmentId = departmentId;
    this.accountmanager = accountmanager;
    this.priorityId = priorityId;
    this.date_done = date_done;
    this.durationEstimate = durationEstimate;
    this.archived = archived;
  }

  public static get EMPTY(): Ticket {
    return new Ticket(
      0,
      "",
      "",
      "",
      0,
      "",
      0,
      0,
      "",
      0,
      0,
      "",
      0,
      null,
      "",
      false
    );
  }

  hasValidValue(): boolean {
    return !!this.title && this.title.trim().length > 0;
  }

  setArchived(archived: boolean): void {
    this.archived = archived;
  }

  getDateDone(): Date | null {
    return this.date_done;
  }

  setDateDone(date: Date | null): void {
    this.date_done = date;
  }

  get hasParts(): boolean {
    return !!this.parts;
  }

  get needsParts(): boolean {
    console.log("needs Parts", this.parts, !this.parts);
    return !this.parts;
  }
}
